import { deleteRequest, getHtmlRequest, getRequest, postRequest } from "../utils/fetch";

const baseUrl: string = "/apicore/inlineedit/";

export interface IAuthResponse {
	token: string;
	refreshToken: string;
	email: string;
	fullName: string;
	avatar: string;
	roles: string[];
	claims: string[];
	domains: string[];
	assemblyVersion: string;
}

export function managementLogin(authToken: string): Promise<IAuthResponse> {
	return postRequest<{ idToken: string }, IAuthResponse>(
		`${window.context.managementApiUrl}/auth/google`,
		{ idToken: authToken },
		{ headers: { "Content-Type": "application/json" } },
	);
}

export function setLoginInfo(authResponse: IAuthResponse): Promise<any> {
	return postRequest<IAuthResponse, any>(`${baseUrl}setlogininfo`, authResponse, {
		headers: { "Content-type": "application/json; charset=utf-8" },
	});
}

export function removeLoginInfo(): Promise<string> {
	return deleteRequest(`${baseUrl}removelogininfo`, {});
}
